import React from 'react';
import Icon, { GLYPHS } from './Icon';
import SquireShopLink from './SquireShopLink';

const year = (new Date()).getFullYear();

const Footer = () => (
  <footer className="u-bg-white">
    <div className="o-wrapper o-wrapper--page">
      <div className="c-footer u-pt+">
        <div className="c-footer__brand u-mb">Squire</div>
        <div className="layout">
          <div className="layout__item u-8/10-medium-and-up">
            <div className="c-footer__company u-mb+">
              <p>
                Squire Technologies is a company<br />
                dedicated to making style and<br />
                grooming for men simple.
              </p>
              <p className="u-mt">&#169; {year} Squire Technologies</p>
            </div>
            <div className="c-footer__section-heading u-co-teal-blue u-mb--">FEEL FREE TO CONTACT US</div>
            <a className="c-footer__email" href="mailto:support@getsquire.com">support@getsquire.com</a>
          </div>
          <div className="layout__item u-2/10-medium-and-up">
            <div className="c-footer__section-heading u-mb">Follow us</div>
            <a
              className="c-footer__social-link"
              href="https://www.linkedin.com/company/5160648"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon glyph={GLYPHS.LINKEDIN} />
            </a>
            <a
              className="c-footer__social-link"
              href="https://twitter.com/getsquire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon glyph={GLYPHS.TWITTER} />
            </a>
            <a
              className="c-footer__social-link"
              href="https://www.facebook.com/SquireTechnologies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon glyph={GLYPHS.FACEBOOK} />
            </a>
            <a
              className="c-footer__social-link"
              href="https://www.instagram.com/getsquire/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon glyph={GLYPHS.INSTAGRAM} />
            </a>
            <SquireShopLink />
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/Footer.jsx